import BaseClient from '@/app/model/api/response/baseApiClient'

class MachineMaintenanceDeleteApi extends BaseClient {
  public doMachineMaintenanceDelete (id: string) {
    const path: string = '/v1/machine-maintenances/' + id

    /* 共通処理 */
    return super.doFetch(process.env.VUE_APP_API_URL + path, 'DELETE')
  }
}

export default new MachineMaintenanceDeleteApi()
